import { CartState } from "@/main/store/cart";

export const INITIAL_CART_STATE: CartState = {
	cartItems: {
		data: [],
		dataNoSupplierAssigned: null,
		dataUnansweredItems: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
		isLoadingUpdate: false,
		idPartIsLoading: null,
		dataUnansweredCanceledItems: null,
	},
	summary: {
		total: 0,
		shippingCost: 0,
		totalParts: 0,
	},
	errorMessagesGeneral: null,
};
